var map = {
	"./icon_playing.svg": 517,
	"./thumbnails/02_hero_desktop.jpg": 237,
	"./thumbnails/02_hero_mobile.jpg": 238,
	"./thumbnails/02_hero_tablet.jpg": 239,
	"./thumbnails/04_hero_desktop.jpg": 240,
	"./thumbnails/04_hero_mobile.jpg": 241,
	"./thumbnails/04_hero_tablet.jpg": 242,
	"./thumbnails/06_hero_desktop.jpg": 243,
	"./thumbnails/06_hero_mobile.jpg": 244,
	"./thumbnails/06_hero_tablet.jpg": 245,
	"./thumbnails/07_hero_desktop.jpg": 246,
	"./thumbnails/07_hero_mobile.jpg": 247,
	"./thumbnails/07_hero_tablet.jpg": 248,
	"./thumbnails/08_hero_desktop.jpg": 249,
	"./thumbnails/08_hero_mobile.jpg": 250,
	"./thumbnails/08_hero_tablet.jpg": 251,
	"./thumbnails/10_hero_desktop.jpg": 252,
	"./thumbnails/10_hero_mobile.jpg": 253,
	"./thumbnails/10_hero_tablet.jpg": 254,
	"./thumbnails/11b_hero_desktop.jpg": 255,
	"./thumbnails/11b_hero_mobile.jpg": 256,
	"./thumbnails/11b_hero_tablet.jpg": 257,
	"./thumbnails/12b_hero_desktop.jpg": 258,
	"./thumbnails/12b_hero_mobile.jpg": 259,
	"./thumbnails/12b_hero_tablet.jpg": 260,
	"./thumbnails/Corteva_Do_More_with_Less.jpg": 261,
	"./thumbnails/Corteva_From_Data_to_Decision.jpg": 262,
	"./thumbnails/Tanzania-Queen-and-Son-small.jpg": 263,
	"./thumbnails/Thailand.jpg": 264,
	"./thumbnails/artOfPrecision-desktop.jpg": 265,
	"./thumbnails/brazil_old_pastures.jpg": 266,
	"./thumbnails/cracking-the-code.jpg": 267,
	"./thumbnails/farmingWithNoRain-desktop.jpg": 268,
	"./thumbnails/foodByPrescription-desktop.jpg": 269,
	"./thumbnails/howTheWorldGrow-desktop.jpg": 270,
	"./thumbnails/seeds-of-change-desktop.jpg": 271,
	"./thumbnails/silicon-farm-thumbnail.jpg": 272,
	"./videoposters/Corteva_Do_More_with_Less-desktop.jpg": 273,
	"./videoposters/Corteva_Do_More_with_Less-mobile.jpg": 274,
	"./videoposters/Corteva_Do_More_with_Less-tablet.jpg": 275,
	"./videoposters/Corteva_From_Data_to_Decision-desktop.jpg": 276,
	"./videoposters/Corteva_From_Data_to_Decision-mobile.jpg": 277,
	"./videoposters/Corteva_From_Data_to_Decision-tablet.jpg": 278,
	"./videoposters/Corteva_How_the_world_grows_TMT-CORT003-120-desktop.jpg": 279,
	"./videoposters/Corteva_How_the_world_grows_TMT-CORT003-120-mobile.jpg": 280,
	"./videoposters/Corteva_How_the_world_grows_TMT-CORT003-120-tablet.jpg": 281,
	"./videoposters/Farming_where_it_doesnt_rain_tablet.png": 282,
	"./videoposters/TMT-CORT010-120-desktop.jpg": 283,
	"./videoposters/TMT-CORT010-120-mobile.jpg": 284,
	"./videoposters/TMT-CORT010-120-tablet.jpg": 285,
	"./videoposters/Tanzania-Queen-and-Son-small-desktop.jpg": 286,
	"./videoposters/Tanzania-Queen-and-Son-small-mobile.jpg": 287,
	"./videoposters/Tanzania-Queen-and-Son-small-tablet.jpg": 288,
	"./videoposters/Thailand-desktop.jpg": 289,
	"./videoposters/Thailand-mobile.jpg": 290,
	"./videoposters/Thailand-tablet.jpg": 291,
	"./videoposters/art-of-precision.jpg": 292,
	"./videoposters/brasil_new_pastures-desktop.jpg": 293,
	"./videoposters/brasil_new_pastures-mobile.jpg": 294,
	"./videoposters/brasil_new_pastures-tablet.jpg": 295,
	"./videoposters/cracking-the-code-desktop.jpg": 296,
	"./videoposters/cracking-the-code-mobile.jpg": 297,
	"./videoposters/cracking-the-code-tablet.jpg": 298,
	"./videoposters/seeds-of-change-desktop.jpg": 299,
	"./videoposters/seeds-of-change-mobile.jpg": 300,
	"./videoposters/seeds-of-change-tablet.jpg": 301,
	"./videoposters/silicon-farm-poster-desktop.jpg": 302,
	"./videoposters/silicon-farm-poster-mobile.jpg": 303,
	"./videoposters/silicon-farm-poster-tablet.jpg": 304
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 516;